<div class="border rounded bg-light p-3 mb-3">
  <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-2">
    <strong class="small">Fila offline</strong>
    <div class="d-flex flex-wrap gap-2 small">
      <span class="badge text-bg-warning">Pendentes {{ totalPendentes }}</span>
      <span class="badge text-bg-danger">Falhas {{ totalFalhas }}</span>
      <span class="badge text-bg-success">Sincronizados {{ totalSincronizados }}</span>
    </div>
  </div>

  <div *ngIf="registros.length === 0" class="text-secondary small">
    Nenhum registro offline armazenado neste terminal.
  </div>

  <div *ngFor="let item of registrosExibidos" class="border-top py-2 text-start small">
    <div class="d-flex justify-content-between gap-2">
      <span>
        {{ item.funcionarioMatricula || '-' }} - {{ item.funcionarioNome || 'Servidor nao informado' }}
      </span>
      <span class="badge" [ngClass]="classeSituacao(item.situacao)">
        {{ rotuloSituacao(item.situacao) }}
      </span>
    </div>
    <div class="text-secondary">
      Criado em {{ item.criadoEm | date:'dd/MM/yyyy HH:mm:ss' }}
      <span *ngIf="item.nsr"> | NSR {{ item.nsr }}</span>
      <span *ngIf="item.tentativas"> | Tentativas {{ item.tentativas }}</span>
    </div>
    <div *ngIf="item.ultimaMensagem" class="text-danger">
      {{ item.ultimaMensagem }}
    </div>
  </div>

  <div *ngIf="registros.length > registrosExibidos.length" class="text-secondary small mt-2">
    Exibindo os ultimos {{ registrosExibidos.length }} registros.
  </div>
</div>
